import styled from '@emotion/native';
import { MARGIN, PADDING } from 'design-system/theme';

export const BodyWrapper = styled.View({
  marginTop: MARGIN.m,
  paddingHorizontal: PADDING.m,
});
